module.exports = __webpack_public_path__ + "static/media/IMG_8864.6a6f6f36.JPG";